import { getAttrValue } from '@grandvisionhq/utils';
import { getLocalizedString } from './get-localized-string.js';

const getLineItemName = (product, locale)=>{
    if (product.productType === 'sunglasses') {
        return String(getAttrValue(product.masterData.current.variant, 'brand'));
    }
    return getLocalizedString(locale, product.masterData.current.name);
};

export { getLineItemName };
//# sourceMappingURL=get-line-item-name.js.map
